import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "emailCount",
    "requiredCredits",
    "availableCredits",
    "stillNeededCredits",
    "requiredSearchQuota",
    "availableSearchQuota",
    "stillNeededSearchQuota",
    "requiredVerifyQuota",
    "availableVerifyQuota",
    "stillNeededVerifyQuota",
    "turboFrame"
  ]
  static values = {
    singleBucket: Boolean,
    emailCount: Number
  }

  connect() {
    // Initialize with email count from data attribute if available
    if (this.emailCountValue && this.hasEmailCountTarget) {
      this.emailCountTarget.textContent = this.emailCountValue
    }

    this.storeOriginalContent()
    this.element.addEventListener('hidden.bs.modal', this.resetModalContent.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('hidden.bs.modal', this.resetModalContent.bind(this))
  }

  storeOriginalContent() {
    const turboFrame = this.element.querySelector('turbo-frame#checkout-modal')
    if (turboFrame) {
      this.originalContent = turboFrame.innerHTML
    }
  }

  resetModalContent() {
    const turboFrame = this.element.querySelector('turbo-frame#checkout-modal')
    if (turboFrame && this.originalContent) {
      turboFrame.innerHTML = this.originalContent
    }
  }

  updateCredits(totalCredits, availableCredits, missingCredits) {
    // Update required credits
    if (this.hasRequiredCreditsTarget) {
      this.requiredCreditsTarget.textContent = this.formatCredits(totalCredits)
    }

    // Update available credits
    if (this.hasAvailableCreditsTarget) {
      this.availableCreditsTarget.textContent = this.formatCredits(availableCredits)
    }

    // Update still needed credits
    if (this.hasStillNeededCreditsTarget) {
      this.stillNeededCreditsTarget.textContent = this.formatCredits(missingCredits)
    }

    // Update stored original content with new values
    this.storeOriginalContent()
  }

  updateQuotas(searchRequired, searchAvailable, searchMissing, verifyRequired, verifyAvailable, verifyMissing) {
    // Update search quotas
    if (this.hasRequiredSearchQuotaTarget) {
      this.requiredSearchQuotaTarget.textContent = this.formatCredits(searchRequired)
    }

    if (this.hasAvailableSearchQuotaTarget) {
      this.availableSearchQuotaTarget.textContent = this.formatCredits(searchAvailable)
    }

    if (this.hasStillNeededSearchQuotaTarget) {
      this.stillNeededSearchQuotaTarget.textContent = this.formatCredits(searchMissing)
    }

    // Update verify quotas
    if (this.hasRequiredVerifyQuotaTarget) {
      this.requiredVerifyQuotaTarget.textContent = this.formatCredits(verifyRequired)
    }

    if (this.hasAvailableVerifyQuotaTarget) {
      this.availableVerifyQuotaTarget.textContent = this.formatCredits(verifyAvailable)
    }

    if (this.hasStillNeededVerifyQuotaTarget) {
      this.stillNeededVerifyQuotaTarget.textContent = this.formatCredits(verifyMissing)
    }

    // Update stored original content with new values
    this.storeOriginalContent()
  }

  updateEmailCount(count) {
    if (this.hasEmailCountTarget) {
      this.emailCountTarget.textContent = count
    }
    this.emailCountValue = count
  }

  formatCredits(value) {
    // Format credits to show .5 if needed, otherwise integer
    if (value % 1 === 0.5) {
      return value.toFixed(1)
    }
    return Math.floor(value).toString()
  }
}
